var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RowContent',{attrs:{"model":_vm.model,"fullName":[_vm.candidate.name, _vm.candidate.surname].join(' ')}})
}
var staticRenderFns = []

export { render, staticRenderFns }